module.exports = __webpack_public_path__ + "fonts/Montserrat-Bold.1f023b34.ttf";